"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleMopUp = exports.drawSpill = void 0;
// eslint-disable-next-line max-statements
var drawSpill = exports.drawSpill = function drawSpill(_ref) {
  var ctx = _ref.ctx,
    isMobileWidth = _ref.isMobileWidth,
    color = _ref.color;
  ctx.beginPath();
  if (isMobileWidth) {
    ctx.moveTo(20, 46);
    ctx.bezierCurveTo(-36, -10, 65, 12, 105, 13);
    ctx.bezierCurveTo(114, 13, 137, 4, 146, 2);
    ctx.bezierCurveTo(243, -10, 140, 45, 259, 56);
    ctx.bezierCurveTo(306, 61, 263, 155, 185, 114);
    ctx.bezierCurveTo(151, 96, 61, 149, 23, 138);
    ctx.bezierCurveTo(-36, 119, 47, 90, 20, 46);
  } else {
    ctx.moveTo(28, 64);
    ctx.bezierCurveTo(-51, -14, 91, 17, 147, 18);
    ctx.bezierCurveTo(160, 18, 192, 5, 204, 4);
    ctx.bezierCurveTo(340, -14, 196, 63, 362, 79);
    ctx.bezierCurveTo(429, 85, 367, 216, 259, 160);
    ctx.bezierCurveTo(212, 134, 85, 209, 32, 193);
    ctx.bezierCurveTo(-51, 167, 66, 127, 28, 64);
  }
  ctx.fillStyle = color;
  ctx.fill();
};
var handleMopUp = exports.handleMopUp = function handleMopUp(_ref2) {
  var e = _ref2.e,
    ctx = _ref2.ctx,
    eraseDiameter = _ref2.eraseDiameter;
  e.preventDefault();
  ctx.beginPath();
  var x = e.layerX;
  var y = e.layerY;
  ctx.globalCompositeOperation = 'destination-out';
  ctx.arc(x, y, eraseDiameter, 0, Math.PI * 2, false);
  ctx.fill();
  ctx.closePath();
};